import React, { useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { FiltersWrapper } from "./filters-styles";
import FilterContainer from "../../library/SearchFilter/SearchFilterContainer";
import FilterGroup from "../../library/SearchFilter/SearchFilterGroup";
import FilterOption from "../../library/SearchFilter/SearchFilterOption";
import { SearchFilterProvider } from "../../library/SearchFilter";
import { DateFilter } from "./DateFilter";
import moment, { Moment } from "moment";
interface AppState {
  employerAnalytics?: {
    resetDefaultFilters?: {
      isFirstRun?: boolean;
    };
  };
}
type Props = {
  filters: {
    jobs?: object;
    sectors?: object;
    pslSectors?: object;
    employer_users?: object;
    agencies?: object;
    timeframe?: string[];
    sortOrder?: string;
    sortBy?: object;
  };
  selectedDateRange: {
    startDate: Moment;
    endDate: Moment;
  };
  // loadJobPerformance: (filterData?: object) => void;
  filterAction: any;
  analyticsFilter: any;
  resetDefaultFilters: any;
  resetDateRangeFilter: () => void;
  dataFilters: any;
  setDataFilters: any;
};

export const Filter = (props: Props) => {
  const scrollToBottom = () => {
    const container = document.getElementById("SearchWrapper");

    if (container) {
      container.scrollTop = container.scrollHeight;
    }
  };

  const handleDocumentClick = (event) => {
    if (
      event.target &&
      (event.target.id === "start-date-id" ||
        event.target.id === "end-date-id" ||
        event.target.id === "timeframe-Custom Date")
    ) {
      setTimeout(() => {
        scrollToBottom();
      }, 300);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);

    // Clean up event listener on component unmount
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const isFirstRun = useSelector(
    (state: AppState) => state.employerAnalytics.resetDefaultFilters.isFirstRun
  );
  const [showDateFields, setShowDateFields] = useState(false);
  const [noResult] = useState(false);
  const {
    filters,
    filterAction,
    selectedDateRange,
    analyticsFilter,
    resetDefaultFilters,
    dataFilters,
    setDataFilters,
    resetDateRangeFilter,
  } = props;
  const [filtersForCount, setFiltersForCount] = useState(dataFilters);
  const submit = () => {
    analyticsFilter(filters, filterAction, true, dataFilters);
    setFiltersForCount(dataFilters);
    resetDefaultFilters({ isFirstRun: false });
  };

  const reset = () => {
    analyticsFilter(filters, filterAction, true, dataFilters);
    setFiltersForCount(dataFilters);
    resetDefaultFilters({ isFirstRun: true });
    resetDateRangeFilter();
  };
  useEffect(() => {
    setDataFilters((prevFilters) => ({
      ...prevFilters,
      ...{
        customStartDate:
          selectedDateRange?.startDate?.format("DD/MM/yyyy") || null,
      },
      ...{
        customEndDate: selectedDateRange?.endDate?.format("DD/MM/yyyy") || null,
      },
    }));
  }, [selectedDateRange]);

  const updateDataFilters = (filtersToUpdate) => {
    if (filtersToUpdate?.pslSectors) {
      setDataFilters((prevFilters) => ({
        ...prevFilters,
        pslSectors: isFirstRun
          ? Object.keys(filtersToUpdate.pslSectors)
          : Object.values(filtersToUpdate.pslSectors),
      }));
    }

    if (filtersToUpdate?.agencies) {
      setDataFilters((prevFilters) => ({
        ...prevFilters,
        agencies: isFirstRun
          ? Object.keys(filtersToUpdate.agencies)
          : Object.values(filtersToUpdate.agencies),
      }));
    }
    if (filtersToUpdate?.jobs) {
      setDataFilters((prevFilters) => ({
        ...prevFilters,
        jobs: isFirstRun
          ? Object.keys(filtersToUpdate.jobs)
          : Object.values(filtersToUpdate.jobs),
      }));
    }
    if (filtersToUpdate?.sectors) {
      setDataFilters((prevFilters) => ({
        ...prevFilters,
        job_sectors: isFirstRun
          ? Object.keys(filtersToUpdate.sectors)
          : Object.values(filtersToUpdate.sectors),
      }));
    }
    if (filtersToUpdate?.employer_users) {
      setDataFilters((prevFilters) => ({
        ...prevFilters,
        employer_users: isFirstRun
          ? Object.keys(filtersToUpdate.employer_users)
          : Object.values(filtersToUpdate.employer_users),
      }));
    }

    if (filtersToUpdate?.pslSectors) {
      setDataFilters((prevFilters) => ({
        ...prevFilters,
        pslSectors: isFirstRun
          ? Object.keys(filtersToUpdate.pslSectors)
          : Object.values(filtersToUpdate.pslSectors),
      }));
    }
    if (filtersToUpdate?.timeframe) {
      setDataFilters((prevFilters) => ({
        ...prevFilters,
        timeframe: isFirstRun
          ? "Last 12 Months"
          : Array.isArray(filtersToUpdate.timeframe)
          ? filtersToUpdate.timeframe[0]
          : filtersToUpdate.timeframe,
      }));
    }
    if (filtersToUpdate?.sortBy) {
      setDataFilters((prevFilters) => ({
        ...prevFilters,
        sortBy: isFirstRun ? "jobs_total_filled" : filtersToUpdate.sortBy,
      }));
    }
    // if (filtersToUpdate?.sortOrder) {
    //   setDataFilters((prevFilters) => ({
    //     ...prevFilters,
    //     sortOrder: isFirstRun ? "desc" : filtersToUpdate.sortOrder,
    //   }));
    // }
    if (filtersToUpdate?.customStartDate) {
      setDataFilters((prevFilters) => ({
        ...prevFilters,
        startDate: isFirstRun ? "" : filtersToUpdate.customStartDate,
      }));
    }
    if (filtersToUpdate?.customEndDate) {
      setDataFilters((prevFilters) => ({
        ...prevFilters,
        endDate: isFirstRun ? "" : filtersToUpdate.customEndDate,
      }));
    }
  };

  useEffect(() => {
    const updateFilters = async () => {
      if (isFirstRun) {
        await updateDataFilters(filters);
      } else {
        await updateDataFilters(dataFilters);
      }
    };

    updateFilters();
  }, [filters]);

  // isOutsideRange function to restrict dates
  const isOutsideRange = (date) => {
    const currentDate = moment();
    const threeYearsAgo = currentDate.clone().subtract(3, "years");
    const startDate = selectedDateRange.startDate;

    // Disable dates outside the allowed range
    if (
      (startDate && date.isBefore(threeYearsAgo)) ||
      date.isAfter(currentDate)
    ) {
      return true;
    }

    if (startDate) {
      const endDateLimit = startDate.clone().add(12, "months").endOf("month");
      return date.isBefore(startDate) || date.isAfter(endDateLimit);
    }

    return false;
  };

  const [disableTimeFrame, setdisableTimeframe] = useState(false);

  return (
    <SearchFilterProvider
      initialValue={dataFilters}
      onChange={(data: any) => {
        setShowDateFields(data.timeframe.includes("Custom Date"));
        setDataFilters(data);
        // setdisableTimeframe(
        //   dataFilters.jobs.length != data.jobs.length && data.jobs.length >= 1
        // );
      }}
      handleReset={reset}
      handleSubmit={submit}
    >
      <FiltersWrapper
        data-id="employer-analytics-filters"
        id="employer-analytics-filters"
        className="animated fadeIn delay-1"
        datePickerActive={true}
      >
        <FilterContainer
          analytics={true}
          selectedFilters={filtersForCount}
          filters={filters}
        >
          {noResult ? (
            <div style={{ padding: "20px 20px", textAlign: "center" }}>
              No Filters found
            </div>
          ) : (
            <>
              {/* {filters.jobs && Object.keys(filters.jobs).length > 0 && (
                <FilterGroup label="Jobs" defaultCollapsed={false}>
                  <FilterOption
                    name="jobs"
                    value={filters?.jobs ? Object.keys(filters.jobs) : []}
                  >
                    Select all
                  </FilterOption>
                  {Object.entries(filters?.jobs || {}).map(([key, value]) => (
                    <FilterOption key={key} name="jobs" value={String(key)}>
                      {value as string}
                    </FilterOption>
                  ))}
                </FilterGroup>
              )} */}
              {filters?.sectors &&
                Object.entries(filters?.sectors).length > 0 && (
                  <FilterGroup label="Job Sector">
                    <FilterOption
                      name="job_sectors"
                      value={
                        filters?.sectors ? Object.keys(filters.sectors) : []
                      }
                    >
                      Select all
                    </FilterOption>
                    {Object.entries(filters?.sectors || {}).map(
                      ([key, value]) => (
                        <FilterOption
                          key={key}
                          name="job_sectors"
                          value={String(key)}
                        >
                          {value as string}
                        </FilterOption>
                      )
                    )}
                  </FilterGroup>
                )}
              {filters?.pslSectors &&
                Object.entries(filters?.pslSectors).length > 0 && (
                  <FilterGroup label="Job Sector">
                    <FilterOption
                      name="pslSectors"
                      value={
                        filters?.pslSectors
                          ? Object.keys(filters.pslSectors)
                          : []
                      }
                    >
                      Select all
                    </FilterOption>
                    {Object.entries(filters?.pslSectors || {}).map(
                      ([key, value]) => (
                        <FilterOption
                          key={key}
                          name="pslSectors"
                          value={String(key)}
                        >
                          {value as string}
                        </FilterOption>
                      )
                    )}
                  </FilterGroup>
                )}
              {filters.agencies && Object.keys(filters.agencies).length > 0 && (
                <FilterGroup label="Agency">
                  <FilterOption
                    name="agencies"
                    value={
                      filters?.agencies ? Object.keys(filters.agencies) : []
                    }
                  >
                    Select all
                  </FilterOption>
                  {Object.entries(filters?.agencies || {}).map(
                    ([key, value]) => (
                      <FilterOption
                        key={key}
                        name="agencies"
                        value={String(key)}
                      >
                        {value as string}
                      </FilterOption>
                    )
                  )}
                </FilterGroup>
              )}
              {filters.employer_users &&
                Object.keys(filters.employer_users).length > 0 && (
                  <FilterGroup label="Employer User">
                    <FilterOption
                      name="employer_users"
                      value={
                        filters?.employer_users
                          ? Object.keys(filters.employer_users)
                          : []
                      }
                    >
                      Select all
                    </FilterOption>
                    {Object.entries(filters?.employer_users || {}).map(
                      ([key, value]) => (
                        <FilterOption
                          key={key}
                          name="employer_users"
                          value={String(key)}
                        >
                          {value as string}
                        </FilterOption>
                      )
                    )}
                  </FilterGroup>
                )}

              {!disableTimeFrame && (
                <FilterGroup label="Timeframe">
                  {(filters?.timeframe || []).map((timeframe) => (
                    <FilterOption
                      single={true}
                      key={timeframe}
                      name="timeframe"
                      value={timeframe}
                    >
                      {timeframe}
                    </FilterOption>
                  ))}

                  {showDateFields && (
                    <div
                      style={{
                        padding: "10px 40px",
                        display: "flex",
                        gap: "10px",
                        width: "100%",
                      }}
                    >
                      <DateFilter isOutsideRange={isOutsideRange} />
                    </div>
                  )}
                </FilterGroup>
              )}
            </>
          )}
        </FilterContainer>
      </FiltersWrapper>
    </SearchFilterProvider>
  );
};

const mapStateToProps = (state) => ({
  selectedDateRange: state.employerAnalytics.selectedDateRange,
});

export default connect(mapStateToProps)(Filter);
